import { getAddress, hexToNumber } from 'viem';

import { get4361Message } from '@/utils';

import { WalletBase } from '../WalletBase';
import { ISignResult } from '../types';

export class EvmWallet extends WalletBase {
  authType = 'MetaMask';
  init(): void {
    if ('ethereum' in window) {
      const provider = window.ethereum;
      this.provider = provider;
    } else {
      window.open('https://metamask.io/', `_blank`);
    }
  }
  async connect(): Promise<boolean> {
    if (!this.provider) return false;
    const accounts = await this.provider.request({
      method: 'eth_requestAccounts'
    });

    const chainIdHex = await this.provider.request({
      method: 'eth_chainId',
      params: []
    });

    this.chainId = hexToNumber(chainIdHex);

    this.address = getAddress(accounts[0]);
    return true;
  }

  async sign(_message: string): Promise<ISignResult> {
    const sign = await this.provider.request({
      method: 'personal_sign',
      params: [_message, this.address]
    });
    return {
      message: _message,
      signature: sign
    };
  }

  override async signin(): Promise<ISignResult> {
    const msgRes = this.getSignInMessage();
    const fullMessage = get4361Message(msgRes);
    const signRes = await this.sign(fullMessage);
    return signRes;
  }

  override getSignEIP712Message(data: { chainId?: number | string; info: string; hash: string }): string {
    return JSON.stringify({
      domain: {
        chainId: data.chainId,
        name: 'EthSign',
        version: '1'
      },
      message: {
        info: data.info,
        hash: data.hash
      },
      primaryType: 'Sign',
      types: {
        // This refers to the domain the contract is hosted on.
        EIP712Domain: [
          { name: 'name', type: 'string' },
          { name: 'version', type: 'string' },
          { name: 'chainId', type: 'uint256' }
        ],
        Sign: [
          { name: 'info', type: 'string' },
          { name: 'hash', type: 'string' }
        ]
      }
    });
  }

  override async signByEIP712(message: string): Promise<ISignResult> {
    if (!this.checkAddressValidity()) {
      throw new Error('Wallet address and user address do not match.');
    }
    this.protocolTag = 'eip712';
    const sign = await this.provider.request({
      method: 'eth_signTypedData_v4',
      params: [this.address, message]
    });
    return {
      message,
      signature: sign
    };
  }

  async decrypt(message: string, address: string): Promise<string> {
    console.log(message, address);
    const res = await this.provider.request({
      method: 'eth_decrypt',
      params: [message, address]
    });

    console.log(res);
    return res;
  }
}
